import {createContext} from 'react';

import {omicronFallback} from '@web-landing/omicron/fetchOmicron';
import {OmicronResponse} from '@web-landing/omicron/schemas';

export const OmicronContext = createContext<OmicronResponse>(omicronFallback);
